import React, {useEffect, useRef, useState} from "react";
import {useExportPtaTierExcel, useReadPtaTierList, useUploadPtaTierExcel,} from "../hooks";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {SubmitHandler, useForm} from "react-hook-form";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {useSearchParams} from "react-router-dom";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

type Props = {};

export const TierList = (props: Props) => {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const defaultSearchValue = {
        keyword: "",
        keywordType: "0",
        limit: 10,
        pageNo: 1,
    };
    const [searchOption, setSearchOption] =
        useState<AccountSearchInterface>(defaultSearchValue);
    const fileRef = useRef<HTMLInputElement>(null);

    const {data: tierData} = useReadPtaTierList({
        searchOption: searchOption,
    });
    const {mutate: exportMutate} = useExportPtaTierExcel();
    const {mutate: uploadMutate} = useUploadPtaTierExcel();

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<AccountSearchInterface> = (submitData) => {
        setSearchOption(submitData);
    };

    const handleButtonClick = () => {
        if (fileRef?.current) {
            fileRef.current.click();
        }
    };

    const handleChange = () => {
        if (fileRef?.current) {
            const data = fileRef.current.files;
            if (data) {
                const form = new FormData();
                form.append("excelFile", data?.[0]);
                uploadMutate(form);
            }
        }
    };

    useEffect(() => {
        setSearchOption({...searchOption, pageNo: page});
    }, [page]);

    const data = tierData?.list;
    const totalCount = tierData?.totalCount;

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">티어 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <form className="row" onSubmit={handleSubmit(onSubmit)}>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                검색어
                            </label>
                            <select
                                className="form-select w-150px"
                                {...register("keywordType")}
                            >
                                <option value="0">전체</option>
                                <option value="1">CLA Number</option>
                                <option value="2">Company ID</option>
                                <option value="3">ERP 거래처</option>
                            </select>
                            <input
                                type="text"
                                className="form-control"
                                {...register("keyword")}
                            />
                            <button className="btn btn-info btn_search">
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                    }
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6"></div>
                </form>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        티어 목록(<span>{totalCount}</span>건)
                    </h6>
                    <div className="table_toolbar">
                        <AuthorityChecker authorityNames={['tierWriteYn']}>
                            <label htmlFor="file-upload">
                                <input
                                    type="file"
                                    className="d-none"
                                    ref={fileRef}
                                    id="file-upload"
                                    onChange={handleChange}
                                />
                                <button
                                    className="btn btn-outline-dark w-150px px-0"
                                    onClick={() => {
                                        handleButtonClick();
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL + "/assets/images/icon_import.png"
                                        }
                                        alt=""
                                    />
                                    엑셀 가져오기
                                </button>
                            </label>
                        </AuthorityChecker>
                        <button
                            className="btn btn-dark w-150px px-0"
                            onClick={() => {
                                exportMutate(searchOption);
                            }}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/icon_export_white.png"
                                }
                                alt=""
                            />
                            엑셀 내보내기
                        </button>
                    </div>
                </div>
                {/* 내부수정: table_scroll 삭제 */}                
                <table className="table table-bordered my_table">
                    <thead>
                    <tr>
                        {/*<th rowSpan={2} style={{ width: "3.76%" }}>*/}
                        {/*  <div className="checkbox_outer">*/}
                        {/*    <input className="form-check-input" type="checkbox" />*/}
                        {/*  </div>*/}
                        {/*</th>*/}
                        <th rowSpan={2} style={{width: "7%"}}>CLA Number</th>
                        <th rowSpan={2} style={{width: "7%"}}>Company ID</th>
                        <th colSpan={2} style={{width: "35%"}}>고객</th>
                        <th rowSpan={2} style={{width: "15%"}}>Company Legal Name</th>
                        <th rowSpan={2} style={{width: "7%"}}>Parent Company ID</th>
                        <th rowSpan={2} style={{width: "15%"}}>Pricing Group</th>
                        <th rowSpan={2} style={{width: "7%"}}>Price Tier</th>
                        <th rowSpan={2} style={{width: "7%"}}>ERP 코드</th>
                    </tr>
                    <tr>
                        <th style={{width: "17.5%"}}>거래처</th>
                        <th style={{width: "17.5%"}}>ERP 거래처</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data?.length === 0 ? (
                        <EmptyTableRow colSpan={9}/>
                    ) : (
                        data?.map((item) => (
                            <tr>
                                {/*<td>*/}
                                {/*  <div className="checkbox_outer">*/}
                                {/*    <input className="form-check-input" type="checkbox" />*/}
                                {/*  </div>*/}
                                {/*</td>*/}
                                <td className="text-center">{item?.claNumber}</td>
                                <td className="text-center">{item?.companyId}</td>
                                <td className="text-center">{item?.accountName}</td>
                                <td className="text-center">{item?.erpAccountName}</td>
                                <td className="text-center">{item?.companyLegalName}</td>
                                <td className="text-center">{item?.parentCompanyId}</td>
                                <td className="text-center">{item?.pricingGroup}</td>
                                <td className="text-center">{item?.priceTier}</td>
                                <td className="text-center">{item?.erpCode}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>

                <PaginationMain totalCount={totalCount ?? 0}/>
            </div>
        </>
    );
};
